module.exports = __webpack_public_path__ + "img/bg@2x.b72b76c3.jpg";